module.exports = __webpack_public_path__ + "static/media/20201216_184917_901_IMG_3142.90116dfc.jpg";